import { createSelector } from '@ngrx/store';
import { SizzleImagesState } from '../reducers/sizzle-images-reducer';

export function sizzleImagesState(state: SizzleImagesState) { return state.imageUrls; }

export const allSizzleImages = createSelector(sizzleImagesState, (_imageUrls => {
	return _imageUrls;
}));
